export default __webpack_public_path__ + "static/1.5-Reading-Focus-Order-DONT-545679865b8a7d0a368130bc1a7ab3ed.png";